import { AxnSessionsState } from "@idw-types/state/axn-sessions-state";
import { AxnSessionsActionTypes, AxnSessionsActions } from "../actions/axn-sessions-actions";

export const initialAxnSessionsState: AxnSessionsState = {
    axnSessions: {
        isLoading: false,
        axnSessions: null
    }
};

export const axnSessionsReducer = (
    state: AxnSessionsState = initialAxnSessionsState,
    action: AxnSessionsActions
): AxnSessionsState => {
    switch (action.type) {
        case AxnSessionsActionTypes.SET_AXN_SESSIONS_LOADING:
            return {
                ...state,
                axnSessions: {
                    ...(action.payload.isLoading
                        ? { ...initialAxnSessionsState.axnSessions }
                        : { ...state.axnSessions }),
                    isLoading: action.payload.isLoading
                }
            };
        case AxnSessionsActionTypes.SET_AXN_SESSIONS:
            return {
                ...state,
                axnSessions: {
                    ...state.axnSessions,
                    axnSessions: action.payload.axnSessions,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};